// Funtion
import adjustViewport from './function/adjustViewport';
import debounce from './function/debounce';

// Module
import DrawerMenu from './module/DrawerMenu';
import Header from './module/Header';
import Modal from './module/Modal';
import SmoothScroll from './module/SmoothScroll';

const init = () => {
  (() => {
    new Header();
    new DrawerMenu();
    new SmoothScroll({
      targets: 'a[href^="#"]',
      fixHeader: '#js-header',
    });
  })();

  (() => {
    new Modal();
  })();

  (() => {
    const debouncedFunction = debounce(() => {
      adjustViewport();
    });
    window.addEventListener('resize', debouncedFunction, false);
    adjustViewport();
  })();
};

window.addEventListener('DOMContentLoaded', () => {
  init();
});
